<script lang="ts">
    import {getInjector} from 'core/svelte-context/context';
    import {BrowserProgressBarService} from 'shared/components/kp-browser-progress-bar/browser-progress-bar.service';
    import {onDestroy} from 'svelte';
    import {unsubscribeAllSubscriptions} from 'shared/utils/observables-utils';
    import {fade} from 'svelte/transition';

    const service = getInjector().getByClass(BrowserProgressBarService);

    let progress = 0;
    let isVisible = false;

    const transitionDuration = service.getSettings().transitionsSpeedMs;
    const transitionEasing = service.getSettings().transitionsEasing;
    const progressSubscription = service.getProgress$.subscribe((currentProgress) => progress = currentProgress);
    const visibilitySubscription = service.getVisibility$.subscribe((currentVisibility) => isVisible = currentVisibility);

    onDestroy(() => {
        unsubscribeAllSubscriptions(progressSubscription, visibilitySubscription);
    });
</script>

{#if isVisible}
    <div class="kp-browser-progress-bar" out:fade={{duration: 250}}>
        <div class="browser-progress-bar"
             style:width="{progress * 100}%"
             style:transition="all {transitionDuration}ms {transitionEasing}">

            <div class="browser-progress-bar-shadow"></div>
        </div>
    </div>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    @progress-start-color: var(--brand-orange-new);
    @progress-end-color: var(--accent-blue-new);

    .kp-browser-progress-bar {
        pointer-events: none;

        .browser-progress-bar {
            background: linear-gradient(to right, @progress-start-color, @progress-end-color);
            position: fixed;
            top: 0;
            left: 0;
            height: 2px;
            z-index: @browser-progress-bar-z-index;

            .browser-progress-bar-shadow {
                display: block;
                position: absolute;
                right: 0;
                width: 100px;
                height: 100%;
                box-shadow: 0 0 10px @progress-end-color, 0 0 5px @progress-end-color;
                transform: rotate(3deg) translate(0px, -4px);
            }
        }
    }
</style>